<!-- Loader -->
@if (isLoading()) {
  <div class="file-preview-lightbox-thumbnail__centered-content">
    <aw-dots-loader [size]="Size.l" [color]="Color.Fog" />
  </div>
}

<!-- File icon -->
@if (view() === 'icon') {
  <div class="file-preview-lightbox-thumbnail__centered-content">
    <aw-file-icon [extension]="getFileExtension()" [size]="Size.xl" />
  </div>
}

<!-- Image thumbnail -->
@if (view() === 'image') {
  <img
    class="file-preview-lightbox-thumbnail__image"
    [class.file-preview-lightbox-thumbnail__image--loaded]="!isLoading()"
    [src]="item().thumbnailUrl"
    [alt]="item().name"
    (load)="imageLoaded()"
    (error)="imageLoadingError()"
  />
}
